import { PrimitiveValueObjectDateTime } from '@/domain/primitiveValueObjectDateTime';

export class LastModifiedDatetime extends PrimitiveValueObjectDateTime {
  /**
   * 作成
   * @param value 値
   * @returns 値
   */
  static create(value: Date): LastModifiedDatetime {
    return new LastModifiedDatetime(value);
  }

  /** ラベル */
  static get label(): string {
    return '更新日時';
  }

  /** 文字列にする */
  override toString() {
    const d = this.value;
    return `${d.getFullYear()}年${d.getMonth() + 1}月${d.getDate()}日 ${d.getHours()}時${d.getMinutes()}分`;
  }
}
